<!--香港务工人员基本信息-->
<template>
    <div class="important-page-c display--flex fd--column">
        <!-- 搜索 -->
        <div
                class="search-form btn-2b5a95"
        >
            <div class="l-w" :style="{
        height: $store.state.global.isSearchExtend_1
          ? ''
          : $store.state.global.searchFormHeight_1 + 10 + 'px',
      }">
                <el-form
                        label-position="right"
                        :class="$store.state.global.isSearchExtend_1 ? '' : 'overflow--hidden'"
                        :model="searchForm"
                        @submit.native.prevent
                >
                    <el-form-item label="姓名:">
                        <el-input
                                v-model.trim="searchForm.fullname"
                                @keyup.enter.native="seach"
                                clearable></el-input>
                    </el-form-item>
                    <el-form-item label="手机号:">
                        <el-input
                                v-model.trim="searchForm.mobile"
                                @keyup.enter.native="seach"
                                clearable></el-input>
                    </el-form-item>
                    <el-form-item label="状态:">
                        <el-input
                                v-model.trim="searchForm.status"
                                @keyup.enter.native="seach"
                                clearable></el-input>
                    </el-form-item>
                    <el-form-item label="教学点:">
                        <el-input
                                v-model.trim="searchForm.schoolorgname"
                                @keyup.enter.native="seach"
                                clearable></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="r-w">

                <el-button
                        type="primary"
                        icon="el-icon-search"
                        @click="seach"
                        :loading="!$store.state.global.isEndRequest"
                        class="btn-2b5a95"
                >搜索</el-button
                >
                <el-button type="primary" @click="resetQuery">重置</el-button>
                <el-button
                        type="primary"
                        :icon="
          $store.state.global.isSearchExtend_1
            ? 'el-icon-arrow-up'
            : 'el-icon-arrow-down'
        "
                        v-if="$store.state.global.searchExtend_1"
                        class="btn-2b5a95"
                        @click="onExtendClick('isSearchExtend_1')"
                >{{ $store.state.global.searchExtendText_1 }}</el-button
                >
            </div>

        </div>

        <!-- 按钮操作 -->
        <div
                class="Btn-w eaf4ff-btn"
                v-if="tableRes.buttonlist && tableRes.buttonlist.length"
                :style="{
        height: $store.state.global.isBtnExtend_1
          ? ''
          : $store.state.global.BtnHeight_1 + 10 + 'px',
      }"
        >
            <div
                    class="btn-l"
                    v-if="tableRes.buttonlist"
                    :class="$store.state.global.isBtnExtend_1 ? '' : 'overflow--hidden'"
            >
                <el-button
                        v-for="(item, index) in tableRes.buttonlist"
                        :key="index"
                        type="primary"
                        @click="onClickBtn(item.buttonname)"
                >{{ item.name }}
                </el-button>
            </div>
            <div class="Btn-extend">
                <el-button
                        type="primary"
                        v-if="$store.state.global.btnExtend_1"
                        class="btn-2b5a95"
                        :icon="
            $store.state.global.isBtnExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
                        @click="onExtendClick('isBtnExtend_1')"
                >{{ $store.state.global.BtnExtendText_1 }}</el-button
                >
            </div>
        </div>

        <!-- 表格 -->
        <el-table
                :data="tableRes.list"
                stripe
                border
                :header-cell-style="{ background: '#044d8c', color: '#fff'}"
                ref="multipleTable"
                style="width: 100%"
                @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
                    label="流水号"
                    prop="id"
                    align="center"
            ></el-table-column>
            <el-table-column
                    label="姓名"
                    prop="fullname"
                    align="center"
            >
                <template slot-scope="scope">
                    <el-button @click="watchDetail(scope.row.id)" type="text"
                    >{{scope.row.fullname}}</el-button
                    >
                </template>

            </el-table-column>
            <el-table-column
                    label="手机"
                    prop="mobile"
                    align="center"
            ></el-table-column>
            <el-table-column
                    label="跟进人"
                    prop="followusername"
                    align="center"
            ></el-table-column>
            <el-table-column label="曾在香港工作" prop="iswork" align="center">
                <template slot-scope="scope">
                    {{ available[scope.row.iswork] }}
                </template>
            </el-table-column>
            <el-table-column
                    label="状态"
                    prop="status"
                    align="center"
            ></el-table-column>
            <el-table-column
                    label="港澳通行证"
                    prop="pass"
                    align="center"
            ></el-table-column>

            <el-table-column label="录入时间" align="center">
                <template slot-scope="scope">
                    {{ scope.row.inserttime | formatDate("YYYY-MM-DD") }}
                </template>
            </el-table-column>

            <el-table-column
                    label="教学点"
                    prop="schoolorgname"
                    align="center"
            ></el-table-column>


            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="text" @click="showPost(scope.row)">已选岗位</el-button>
                </template>
            </el-table-column>

        </el-table>

        <!-- 分页 -->
        <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page="pageinfo.pageindex"
                :page-size="pageinfo.pagesize"
                :page-sizes="[10, 20, 30, 40, 50]"
                layout="total, prev, pager, next, jumper"
                :total="tableRes.totalcount"
        ></el-pagination>

        <!--添加，修改-->
        <el-dialog
                class="btn-2b5a95"
                width="1400px"
                v-dialogDrag
                :title="dialogTitle"
                :close-on-click-modal='false'
                :visible.sync="showAddModal"
                v-if="showAddModal"
                append-to-body
        >
            <el-form
                    :model="dynamicValidateForm"
                    ref="dynamicValidateForm"

                    class="demo-dynamic form-item-w-20"
                    status-icon
                    :rules="rules"
            >

                <el-form-item prop="companyorgname" label="分公司">
                    <el-select
                            v-model="dynamicValidateForm.companyorgname"
                            placeholder="请选择"
                            :disabled="!$store.state.login.isMaxAuth"
                            clearable
                            @change="onChangeCompany($event, 'dynamicValidateForm')"
                    >
                        <el-option
                                v-for="item in $store.state.selectData.companyList"
                                :key="item.key"
                                :label="item.val"
                                :value="item.key"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="schoolorgid" label="教学点">
                    <el-select
                            v-model="dynamicValidateForm.schoolorgname"
                            :disabled="!$store.state.login.isMaxAuth"
                            placeholder="请选择"
                            clearable
                            @change="onChangeSchool($event, 'dynamicValidateForm')"
                    >
                        <el-option
                                v-for="item in $store.state.selectData.schoolList"
                                :key="item.key"
                                :label="item.val"
                                :value="item.key"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="姓名:" prop="fullname">
                    <el-input v-model.trim="dynamicValidateForm.fullname" class="input_150" clearable></el-input>
                </el-form-item>

                <el-form-item label="性别" prop="sexval">
                    <el-select v-model="dynamicValidateForm.sexval" class="select_1">
                        <el-option label="男" value="男" />
                        <el-option label="女" value="女" />
                    </el-select>
                </el-form-item>

                <el-form-item label="生日" prop="birthday" >
                    <el-date-picker
                            v-model="dynamicValidateForm.birthday"
                            type="date"
                            placeholder="请选择"
                    />
                </el-form-item>

                <el-form-item label="年龄:" prop="age">
                    <el-input v-model.trim="dynamicValidateForm.age" class="input_100" clearable></el-input>
                </el-form-item>

                <el-form-item label="身高:" prop="height">
                    <el-input v-model.trim="dynamicValidateForm.height" class="input_100" clearable>
                        <i slot="suffix">CM</i>
                    </el-input>

                </el-form-item>

                <el-form-item label="体重:" prop="weight">
                    <el-input v-model.trim="dynamicValidateForm.weight" class="input_100" clearable>
                        <i slot="suffix">KG</i>
                    </el-input>
                </el-form-item>

                <el-form-item label="籍贯:" prop="comefrom">
                    <el-input v-model.trim="dynamicValidateForm.comefrom" class="input_200" clearable></el-input>
                </el-form-item>

                <el-form-item label="婚姻状况" prop="marryval">
                    <el-select v-model="dynamicValidateForm.marryval" class="select_1" clearable>
                        <el-option label="未婚" value="未婚" />
                        <el-option label="已婚" value="已婚" />
                    </el-select>
                </el-form-item>

                <el-form-item label="民族:" prop="nationval">
                    <el-select v-model="dynamicValidateForm.nationval" class="select_1" clearable>
                        <el-option
                                v-for="(item, index) in nationList"
                                :key="index"
                                :label="item.val"
                                :value="item.val"
                        />
                    </el-select>
                </el-form-item>

                <el-form-item label="现住地址:" prop="nowaddr">
                    <el-input v-model.trim="dynamicValidateForm.nowaddr" class="input_2" clearable></el-input>
                </el-form-item>
                <el-form-item  label="手机号:" prop="mobile">
                    <el-input
                            v-model.trim="dynamicValidateForm.mobile"
                            :disabled="addEditDisable"
                            maxlength="11"
                            autocomplete="off"
                            clearable
                    />
                </el-form-item>
                <el-form-item label="技术职称/专业证书:" prop="certificate">
                    <el-input v-model.trim="dynamicValidateForm.certificate" class="input_2" clearable></el-input>
                </el-form-item>
                <el-form-item label="身份证号码:" prop="idcard">
                    <el-input v-model.trim="dynamicValidateForm.idcard" class="input_2" clearable></el-input>
                </el-form-item>
                <el-form-item label="紧急联系人及电话:" prop="urgentperson">
                    <el-input v-model.trim="dynamicValidateForm.urgentperson" class="input_2" clearable></el-input>
                </el-form-item>
                <el-form-item label="户籍地址:" prop="domicile">
                    <el-input v-model.trim="dynamicValidateForm.domicile" class="input_2" clearable></el-input>
                </el-form-item>
                <el-form-item label="曾在香港工作:" prop="iswork">
                    <el-select v-model="dynamicValidateForm.iswork" class="select_1">
                        <el-option label="否" :value="0" />
                        <el-option label="是" :value="1" />
                    </el-select>
                </el-form-item>
                <el-form-item label="港澳通行证号码:" prop="pass">
                    <el-input v-model.trim="dynamicValidateForm.pass" class="input_2" clearable></el-input>
                </el-form-item>
                <el-form-item  label="跟进人:" prop="followusername">
                    <el-input v-model.trim="dynamicValidateForm.followusername" disabled />
                    <el-button
                            type="primary"
                            class="select-btn"
                            :disabled="followDisabled"
                            @click="
              onSelectData(vuser_dialogresult, 'showFollowDataModal', {
                schoolorgid: dynamicValidateForm.schoolorgid,
                leaveflag: 0,
              })
            "
                    >选择</el-button
                    >
                </el-form-item>

                <div class="div_1">
                <p class="p_1">受教育情况（从高向低填）</p>
                <div
                        v-for="(item, i) in dynamicValidateForm.moreItems1"
                        :key="item.id"
                        class="more-form-item-w box-w-33"
                >
                    <el-form-item
                            label="就读时间:"
                            :prop="'moreItems1.' + i + '.studytime'"
                    >
                        <el-input v-model.trim="item.studytime" clearable></el-input>
                    </el-form-item>
                    <el-form-item
                            label="学校："
                            :prop="'moreItems1.' + i + '.collegename'"

                    >
                        <el-input v-model.trim="item.collegename" clearable></el-input>
                    </el-form-item>
                    <el-form-item
                            label="专业："
                            :prop="'moreItems1.' + i + '.majorname'"
                    >
                        <el-input v-model.trim="item.majorname" clearable></el-input>
                    </el-form-item>
                    <el-form-item
                            label="学历："
                            :prop="'moreItems1.' + i + '.education'"
                    >
                        <el-input v-model.trim="item.education" clearable></el-input>
                    </el-form-item>
                    <el-button
                            v-if="i !== 0"
                            @click="report_onRemoveMoreForm(i, 'moreItems1')"
                            style="margin: 0 10px; height: 40px">删除</el-button>
                </div>
                <el-button @click="report_addFormItem1" style="margin: 10px">添加一行</el-button>
                </div>

                <p></p>
                <el-form-item label="粤语阅读" prop="read">
                    <el-select v-model="dynamicValidateForm.read" class="select_1">
                        <el-option label="不会" value="不会" />
                        <el-option label="一般" value="一般" />
                        <el-option label="熟练" value="熟练" />
                    </el-select>
                </el-form-item>
                <el-form-item label="粤语听说" prop="heard">
                    <el-select v-model="dynamicValidateForm.heard" class="select_1">
                        <el-option label="不会" value="不会" />
                        <el-option label="一般" value="一般" />
                        <el-option label="熟练" value="熟练" />
                    </el-select>
                </el-form-item>
                <el-form-item label="粤语写作" prop="write">
                    <el-select v-model="dynamicValidateForm.write" class="select_1">
                        <el-option label="不会" value="不会" />
                        <el-option label="一般" value="一般" />
                        <el-option label="熟练" value="熟练" />
                    </el-select>
                </el-form-item>
                <el-form-item label="粤语考试种类及等级:" prop="grade">
                    <el-input v-model.trim="dynamicValidateForm.grade" clearable></el-input>
                </el-form-item>
                <p></p>
                <el-form-item label="英语阅读" prop="read2">
                    <el-select v-model="dynamicValidateForm.read2" class="select_1">
                        <el-option label="不会" value="不会" />
                        <el-option label="一般" value="一般" />
                        <el-option label="熟练" value="熟练" />
                    </el-select>
                </el-form-item>
                <el-form-item label="英语听说" prop="heard2">
                    <el-select v-model="dynamicValidateForm.heard2" class="select_1">
                        <el-option label="不会" value="不会" />
                        <el-option label="一般" value="一般" />
                        <el-option label="熟练" value="熟练" />
                    </el-select>
                </el-form-item>
                <el-form-item label="英语写作" prop="write2">
                    <el-select v-model="dynamicValidateForm.write2" class="select_1">
                        <el-option label="不会" value="不会" />
                        <el-option label="一般" value="一般" />
                        <el-option label="熟练" value="熟练" />
                    </el-select>
                </el-form-item>
                <el-form-item label="英语考试种类及等级:" prop="grade2">
                    <el-input v-model.trim="dynamicValidateForm.grade2"  clearable></el-input>
                </el-form-item>

                <p></p>
                <div class="div_1">
                <div class="title">工作经历（从后向前填）</div>
                <div
                        v-for="(item, i) in dynamicValidateForm.moreItems2"
                        :key="item.id"
                        class="more-form-item-w box-w-25"
                >
                    <el-form-item
                            label="起止时间："
                            :prop="'moreItems2.' + i + '.startendtime'"

                    >
                        <el-input v-model.trim="item.startendtime" class="input_1" clearable></el-input>

                    </el-form-item>

                    <el-form-item
                            label="工作单位及部门："
                            :prop="'moreItems2.' + i + '.workunit'"
                    >
                        <el-input v-model.trim="item.workunit" class="input_1" clearable></el-input>
                    </el-form-item>
                    <el-form-item
                            label="担任职务或工作岗位："
                            :prop="'moreItems2.' + i + '.post'"
                    >
                        <el-input v-model.trim="item.post" class="input_1" clearable></el-input>
                    </el-form-item>
                    <el-form-item
                            label="职责范围："
                            :prop="'moreItems2.' + i + '.responsibility'"
                    >
                        <el-input v-model.trim="item.responsibility" class="input_1" clearable></el-input>
                    </el-form-item>

                    <el-form-item label="工作证明材料:"
                                  :prop="'moreItems2.' + i + '.workurl'">
                        <el-input v-model="item.workurl" class="input_1" />
                        <el-upload
                                class="upload-demo"
                                :action="$store.state.global.baseUrl"
                                multiple
                                :show-file-list="false"
                                :before-upload="beforeUpload"
                                :http-request ="() =>uploadFile2(i)"
                        >
                            <el-button type="primary" class="select-btn">点击上传</el-button>

                            <div slot="tip" class="el-upload__tip"></div>
                        </el-upload>
                    </el-form-item>


                    <el-button
                            v-if="i !== 0"
                            @click="report_onRemoveMoreForm(i, 'moreItems2')"
                            style="margin: 0 10px; height: 40px"
                    >删除</el-button
                    >
                </div>
                <el-button @click="report_addFormItem2" style="margin: 10px">添加一行</el-button>
                </div>

                <el-form-item label="欲从事工作①:" prop="work1">
                    <el-input v-model.trim="dynamicValidateForm.work1" class="input_1" clearable></el-input>
                </el-form-item>
                <el-form-item label="欲从事工作②:" prop="work2">
                    <el-input v-model.trim="dynamicValidateForm.work2" class="input_1" clearable></el-input>
                </el-form-item>
                <el-form-item label="欲从事工作③:" prop="work3">
                    <el-input v-model.trim="dynamicValidateForm.work3" class="input_1" clearable></el-input>
                </el-form-item>
                <el-form-item label="欲从事工作④:" prop="work4">
                    <el-input v-model.trim="dynamicValidateForm.work4" class="input_1" clearable></el-input>
                </el-form-item>
                <p></p>
                <el-form-item label="特长：" prop="talent" label-width="100px">
                    <el-input v-model.trim="dynamicValidateForm.talent" class="" clearable></el-input>
                </el-form-item>
                <el-form-item label="现时工资:" prop="nowwages" label-width="100px">
                    <el-input v-model.trim="dynamicValidateForm.nowwages" class="input_1" clearable></el-input>
                </el-form-item>
                <el-form-item label="期望工资:" prop="hopewages" label-width="100px">
                    <el-input v-model.trim="dynamicValidateForm.hopewages" class="input_1" clearable></el-input>
                </el-form-item>
                <el-form-item label="备注:" prop="remarks" label-width="100px">
                    <el-input v-model.trim="dynamicValidateForm.remarks" class="input_1" clearable></el-input>
                </el-form-item>

                <div class="div_1">
                <div class="title">资料上传</div>
                    <el-form-item prop="pic" label="照片:">
                        <el-input v-model="dynamicValidateForm.pic"  />
                        <el-upload
                                class="upload-demo"
                                :action="$store.state.global.baseUrl"
                                multiple
                                :before-upload="beforeUpload"
                                :http-request="() => uploadFile('pic')"
                                :show-file-list="false"
                        >
                            <el-button type="primary" class="select-btn">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip"></div>
                        </el-upload>
                    </el-form-item>
                <el-form-item prop="idphoto" label="身份证正面:">
                    <el-input v-model="dynamicValidateForm.idphoto"  />
                    <el-upload
                            class="upload-demo"
                            :action="$store.state.global.baseUrl"
                            multiple
                            :before-upload="beforeUpload"
                            :http-request="() => uploadFile('idphoto')"
                            :show-file-list="false"
                    >
                        <el-button type="primary" class="select-btn">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip"></div>
                    </el-upload>
                </el-form-item>
                    <el-form-item prop="idphoto2" label="身份证反面:">
                        <el-input v-model="dynamicValidateForm.idphoto2"  />
                        <el-upload
                                class="upload-demo"
                                :action="$store.state.global.baseUrl"
                                multiple
                                :before-upload="beforeUpload"
                                :http-request="() => uploadFile('idphoto2')"
                                :show-file-list="false"
                        >
                            <el-button type="primary" class="select-btn">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip"></div>
                        </el-upload>
                    </el-form-item>

                    <el-form-item prop="passphoto" label="港澳通行证正面:">
                        <el-input v-model="dynamicValidateForm.passphoto"  />
                        <el-upload
                                class="upload-demo"
                                :action="$store.state.global.baseUrl"
                                multiple
                                :before-upload="beforeUpload"
                                :http-request="() => uploadFile('passphoto')"
                                :show-file-list="false"
                        >
                            <el-button type="primary" class="select-btn">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip"></div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item prop="passphoto2" label="港澳通行证反面:">
                        <el-input v-model="dynamicValidateForm.passphoto2"  />
                        <el-upload
                                class="upload-demo"
                                :action="$store.state.global.baseUrl"
                                multiple
                                :before-upload="beforeUpload"
                                :http-request="() => uploadFile('passphoto2')"
                                :show-file-list="false"
                        >
                            <el-button type="primary" class="select-btn">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip"></div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item prop="registerphoto" label="户口本:">
                        <el-input v-model="dynamicValidateForm.registerphoto"  />
                        <el-upload
                                class="upload-demo"
                                :action="$store.state.global.baseUrl"
                                multiple
                                :before-upload="beforeUpload"
                                :http-request="() => uploadFile('registerphoto')"
                                :show-file-list="false"
                        >
                            <el-button type="primary" class="select-btn">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip"></div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item prop="bodyphoto" label="全身照:">
                        <el-input v-model="dynamicValidateForm.bodyphoto"  />
                        <el-upload
                                class="upload-demo"
                                :action="$store.state.global.baseUrl"
                                multiple
                                :before-upload="beforeUpload"
                                :http-request="() => uploadFile('bodyphoto')"
                                :show-file-list="false"
                        >
                            <el-button type="primary" class="select-btn">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip"></div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item prop="flairphoto" label="资质证书:">
                        <el-input v-model="dynamicValidateForm.flairphoto"  />
                        <el-upload
                                class="upload-demo"
                                :action="$store.state.global.baseUrl"
                                multiple
                                :before-upload="beforeUpload"
                                :http-request="() => uploadFile('flairphoto')"
                                :show-file-list="false"
                        >
                            <el-button type="primary" class="select-btn">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip"></div>
                        </el-upload>
                    </el-form-item>
                    <!--
                    <el-form-item prop="videourl" label="工作或个人介绍视频:">
                        <el-input v-model="dynamicValidateForm.videourl"  />
                        <el-upload
                                class="upload-demo"
                                :action="$store.state.global.baseUrl"
                                multiple
                                :before-upload="beforeUpload"
                                :http-request="() => uploadFile('videourl')"
                                :show-file-list="false"
                        >
                            <el-button type="primary" class="select-btn">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip"></div>
                        </el-upload>
                    </el-form-item> -->

                </div>







            </el-form>
            <span slot="footer" class="dialog-footer">
        <el-button
                type="primary"
                @click="submitAddOrEditForm('dynamicValidateForm')"
                :loading="!$store.state.global.isEndRequest"
        >提交
        </el-button>
      </span>
        </el-dialog>


        <!-- 选择跟进人 -->
        <el-dialog
                class="btn-2b5a95"
                width="50%"
                v-dialogDrag
                @close="onHandleCloseSelect"
                title="选择跟进人："
                :close-on-click-modal='false'
                :visible.sync="showFollowDataModal"
                v-if="showFollowDataModal"
                append-to-body
        >
            <el-button type="primary" class="confirm" @click="followDataComfirm"
            >确 定</el-button
            >
            <div class="index_2 btn-2b5a95">
                <div
                        class="l-w"
                        :style="{
            height: $store.state.global.isSearchExtend_2
              ? ''
              : $store.state.global.searchFormHeight_2 + 10 + 'px',
          }"
                >
                    <el-form
                            label-position="right"
                            :class="
              $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
            "
                            :model="selectSearchForm"
                            @submit.native.prevent
                    >
                        <el-form-item label="真实姓名:" prop="realname">
                            <el-input
                                    v-model.trim="selectSearchForm.realname"
                                    @keyup.enter.native="onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign(
                  {
                    schoolorgid: dynamicValidateForm.schoolorgid,
                    leaveflag: 0,
                  },
                  selectSearchForm
                )
              )"
                                    clearable />
                        </el-form-item>
                    </el-form>
                </div>
                <div class="r-w">
                    <el-button
                            type="primary"
                            icon="el-icon-search"
                            :loading="!$store.state.global.isEndRequest"
                            class="btn-2b5a95"
                            @click="
              onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign(
                  {
                    schoolorgid: dynamicValidateForm.schoolorgid,
                    leaveflag: 0,
                  },
                  selectSearchForm
                )
              )
            "
                    >搜索</el-button
                    >
                    <!-- <el-button type="primary" @click="handleQuery">重置</el-button> -->
                    <el-button
                            type="primary"
                            :icon="
              $store.state.global.isSearchExtend_2
                ? 'el-icon-arrow-up'
                : 'el-icon-arrow-down'
            "
                            v-if="$store.state.global.searchExtend_2"
                            class="btn-2b5a95"
                            @click="onExtendClick('isSearchExtend_2')"
                    >{{ $store.state.global.searchExtendText_2 }}</el-button
                    >
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                    :data="selectTable.list"
                    style="width: 100%"
                    border
                    :key="key"
                    stripe
                    :header-cell-style="{background: '#004d8c', color:'#FFFFFF'}"
                    @select="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" />
                <el-table-column label="流水号" prop="id" align="center" />
                <el-table-column label="姓名" prop="realname" align="center" />
                <el-table-column label="岗位" prop="positionname" align="center" />
                <el-table-column
                        label="所属教学点"
                        prop="schoolorgname"
                        align="center"
                />
            </el-table>
            <!-- 分页 -->
            <el-pagination
                    background
                    @current-change="
          (val, data, prop, page) =>
            handleSelectChange(
              val,
              Object.assign(
                {
                  schoolorgid: dynamicValidateForm.schoolorgid,
                  leaveflag: 0,
                },
                selectSearchForm
              )
            )
        "
                    :current-page="selectPageInfo.pageindex"
                    :page-size="selectPageInfo.pagesize"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    layout="total, prev, pager, next, jumper"
                    :total="selectTable.totalcount"
            ></el-pagination>
        </el-dialog>

        <!-- 	查看详情 -->
        <div id="RightOffside" class="RightOffside" v-show="showDetailModal">
            <!-- 按钮组 -->
            <div class="Offside_btnBox">
                <div class="Offside_Btn Offside_CloseBtn" @click="handleShow"></div>
                <div class="Offside_Btn"
                     v-for="(item,index) in tabList"
                     :key="index"
                     :class="{active:currentClass === index}"
                     @click="toggleTab(index)"
                >
                    {{item}}
                </div>
            </div>
            <div class="OrderStatusTips">
                <span class="pull-left text-blue">人员信息</span>
            </div>
            <!-- 切换栏 -->
            <div>
                <div class="OrderContentBox" v-show="currentTab === 0">
                    <div class="order-card x-basic abase-card" style="width:950px;background-color: #D1EEEE; margin-bottom: 30px;">
                        <div class="top_el">
                            基本信息
                        </div>
                        <el-form>
                            <table class="tabledetail_1" style="width: 100%;" bgcolor="#D1EEEE" cellpadding="5px">
                                <tbody>
                                <tr>
                                    <td class="ltd_el">姓名：{{ vworkers.fullname }}</td>
                                    <td class="ltd_el">性别：{{ vworkers.sexval }}</td>
                                    <td class="ltd_el">出生日期：{{ vworkers.birthday | formatDate("YYYY-MM-DD") }}</td>
                                    <td class="ltd_el">年龄：{{ vworkers.age }}</td>
                                    <td rowspan="5" align="center" valign="middle">
                                        <img
                                                style="width: 161px; height: 200px"
                                                :src="vworkers.pic ? this.$url.upload + vworkers.pic : ''"
                                        />
                                        <p>照片</p>
                                    </td>
                                </tr>

                                <tr>
                                    <td class="ltd_el">身高：{{ vworkers.height }} cm</td>
                                    <td class="ltd_el">体重：{{ vworkers.weight }} kg</td>
                                    <td class="ltd_el">籍贯：{{ vworkers.comefrom }}</td>
                                    <td class="ltd_el">婚否：{{ vworkers.marryval }}</td>
                                </tr>

                                <tr>
                                    <td class="ltd_el">民族：{{ vworkers.nationval }}</td>
                                    <td class="ltd_el" colspan="3">现住地址：{{ vworkers.nowaddr }}</td>
                                </tr>

                                <tr>
                                    <td class="ltd_el" colspan="1">电话：{{ vworkers.mobile }}</td>
                                    <td class="ltd_el" colspan="3">技术职称/专业证书：{{ vworkers.certificate }}</td>
                                </tr>

                                <tr>
                                    <td class="ltd_el" colspan="2">身份证号码：{{ vworkers.idcard }}</td>
                                    <td class="ltd_el" colspan="2">紧急联系人及电话：{{ vworkers.urgentperson }}</td>
                                </tr>

                                <tr>

                                    <td class="ltd_el" colspan="2">户籍地址：{{ vworkers.domicile }}</td>
                                    <td class="ltd_el" colspan="3">是否曾在香港工作：{{ vworkers.iswork ==1 ? "是":"否" }}</td>
                                </tr>

                                <tr>
                                    <td class="ltd_el" colspan="5">港澳通行证号码：{{ vworkers.pass }}</td>
                                </tr>

                                <tr>
                                    <td align="center" :rowspan="list1.length + 1">受<br>教<br>育<br>情<br>况</td>
                                    <td class="ltd_el">就读时间</td>
                                    <td class="ltd_el">学校</td>
                                    <td class="ltd_el">专业</td>
                                    <td class="ltd_el">学历</td>
                                </tr>

                                <tr v-for="item in list1" :key="item.id">
                                    <td class="ltd_el">{{item.studytime}}</td>
                                    <td class="ltd_el">{{item.collegename}}</td>
                                    <td class="ltd_el">{{item.majorname}}</td>
                                    <td class="ltd_el">{{item.education}}</td>
                                </tr>
                                <!--
                                <tr>
                                    <td class="tr_1"></td>
                                    <td class="ltd_el"></td>
                                    <td class="ltd_el"></td>
                                    <td class="ltd_el"></td>
                                </tr> -->
                                <tr>
                                    <td align="center" rowspan="2">语言<br>水平</td>
                                    <td class="ltd_el">粤语阅读:{{vworkers.read}}</td>
                                    <td class="ltd_el">粤语听说:{{vworkers.heard}}</td>
                                    <td class="ltd_el">粤语写作:{{vworkers.write}}</td>
                                    <td class="ltd_el">粤语考试种类及等级:{{vworkers.grade}}</td>
                                </tr>

                                <tr>
                                    <td class="ltd_el">英语阅读:{{vworkers.read2}}</td>
                                    <td class="ltd_el">英语听说:{{vworkers.heard2}}</td>
                                    <td class="ltd_el">英语写作:{{vworkers.write2}}</td>
                                    <td class="ltd_el">英语考试种类及等级:{{vworkers.grade2}}</td>
                                </tr>

                                <tr>
                                    <td :rowspan="list2.length + 1" align="center">工<br>作<br>经<br>历</td>
                                    <td class="ltd_el">起止时间</td>
                                    <td class="ltd_el">工作单位及部门</td>
                                    <td class="ltd_el">担任职务或工作岗位</td>
                                    <td class="ltd_el">职责范围</td>
                                </tr>
                                <tr v-for="item in list2" :key="item.id">
                                    <td class="ltd_el">{{item.startendtime}}</td>
                                    <td class="ltd_el">{{item.workunit}}</td>
                                    <td class="ltd_el">{{item.post}}</td>
                                    <td class="ltd_el">{{item.responsibility}}</td>
                                </tr>

                                <tr>
                                    <td align="center" rowspan="3">求<br>职<br>意<br>向</td>
                                    <td>欲从事工作①:{{vworkers.work1}}</td>
                                    <td>欲从事工作②:{{vworkers.work2}}</td>
                                    <td>欲从事工作③:{{vworkers.work3}}</td>
                                    <td>欲从事工作④:{{vworkers.work4}}</td>
                                </tr>
                                <tr>
                                    <td colspan="4">有何特长:{{vworkers.talent}}</td>
                                </tr>
                                <tr>
                                    <td colspan="2">现时工资:{{vworkers.nowwages}}</td>
                                    <td colspan="2">求职希望工资:{{vworkers.hopewages}}</td>
                                </tr>

                                <tr>
                                    <td align="center">备<br>注</td>
                                    <td colspan="4">{{vworkers.remarks}}</td>
                                </tr>




                                </tbody>
                            </table>
                        </el-form>
                    </div>
                </div>

                <div class="OrderContentBox" v-show="currentTab === 1">
                    <div class="demo-image__preview demo-image__error">
                        <el-card shadow="hover" class="el-card_image_next">
                            <p class="demonstration text-align text-blue">身份证正面</p>
                            <div class="image_pic_el">
                                <el-image
                                        class="adaptation"
                                        :src="vworkers.idphoto ? $url.upload + vworkers.idphoto : ''"
                                        @click="vbs(vworkers.idphoto ? $url.upload + vworkers.idphoto : '')"
                                        :preview-src-list="srcList"
                                        :z-index="99999"
                                >
                                    <div slot="error" class="image-slot el-image__error">
                                        <i class="el-icon-picture-outline"></i>
                                        <span>暂无图片</span>
                                    </div>
                                </el-image>
                            </div>
                        </el-card>

                        <el-card shadow="hover" class="el-card_image_next">
                            <p class="demonstration text-align text-blue">身份证反面</p>
                            <div class="image_pic_el">
                                <el-image
                                        class="adaptation"
                                        :src="vworkers.idphoto2 ? $url.upload + vworkers.idphoto2 : ''"
                                        @click="vbs(vworkers.idphoto2 ? $url.upload + vworkers.idphoto2 : '')"
                                        :preview-src-list="srcList"
                                        :z-index="99999"
                                >
                                    <div slot="error" class="image-slot el-image__error">
                                        <i class="el-icon-picture-outline"></i>
                                        <span>暂无图片</span>
                                    </div>
                                </el-image>
                            </div>
                        </el-card>

                        <el-card shadow="hover" class="el-card_image_next">
                            <p class="demonstration text-align text-blue">港澳通行证正面</p>
                            <div class="image_pic_el">
                                <el-image
                                        class="adaptation"
                                        :src="vworkers.passphoto ? $url.upload + vworkers.passphoto : ''"
                                        @click="vbs(vworkers.passphoto ? $url.upload + vworkers.passphoto : '')"
                                        :preview-src-list="srcList"
                                        :z-index="99999"
                                >
                                    <div slot="error" class="image-slot el-image__error">
                                        <i class="el-icon-picture-outline"></i>
                                        <span>暂无图片</span>
                                    </div>
                                </el-image>
                            </div>
                        </el-card>

                        <el-card shadow="hover" class="el-card_image_next">
                            <p class="demonstration text-align text-blue">港澳通行证反面</p>
                            <div class="image_pic_el">
                                <el-image
                                        class="adaptation"
                                        :src="vworkers.passphoto2 ? $url.upload + vworkers.passphoto2 : ''"
                                        @click="vbs(vworkers.passphoto2 ? $url.upload + vworkers.passphoto2 : '')"
                                        :preview-src-list="srcList"
                                        :z-index="99999"
                                >
                                    <div slot="error" class="image-slot el-image__error">
                                        <i class="el-icon-picture-outline"></i>
                                        <span>暂无图片</span>
                                    </div>
                                </el-image>
                            </div>
                        </el-card>

                        <el-card shadow="hover" class="el-card_image_next">
                            <p class="demonstration text-align text-blue">户口本</p>
                            <div class="image_pic_el">
                                <el-image
                                        class="adaptation"
                                        :src="vworkers.registerphoto ? $url.upload + vworkers.registerphoto : ''"
                                        @click="vbs(vworkers.registerphoto ? $url.upload + vworkers.registerphoto : '')"
                                        :preview-src-list="srcList"
                                        :z-index="99999"
                                >
                                    <div slot="error" class="image-slot el-image__error">
                                        <i class="el-icon-picture-outline"></i>
                                        <span>暂无图片</span>
                                    </div>
                                </el-image>
                            </div>
                        </el-card>

                        <el-card shadow="hover" class="el-card_image_next">
                            <p class="demonstration text-align text-blue">全身照</p>
                            <div class="image_pic_el">
                                <el-image
                                        class="adaptation"
                                        :src="vworkers.bodyphoto ? $url.upload + vworkers.bodyphoto : ''"
                                        @click="vbs(vworkers.bodyphoto ? $url.upload + vworkers.bodyphoto : '')"
                                        :preview-src-list="srcList"
                                        :z-index="99999"
                                >
                                    <div slot="error" class="image-slot el-image__error">
                                        <i class="el-icon-picture-outline"></i>
                                        <span>暂无图片</span>
                                    </div>
                                </el-image>
                            </div>
                        </el-card>

                        <el-card shadow="hover" class="el-card_image_next">
                            <p class="demonstration text-align text-blue">资质证书</p>
                            <div class="image_pic_el">
                                <el-image
                                        class="adaptation"
                                        :src="vworkers.flairphoto ? $url.upload + vworkers.flairphoto : ''"
                                        @click="vbs(vworkers.flairphoto ? $url.upload + vworkers.flairphoto : '')"
                                        :preview-src-list="srcList"
                                        :z-index="99999"
                                >
                                    <div slot="error" class="image-slot el-image__error">
                                        <i class="el-icon-picture-outline"></i>
                                        <span>暂无图片</span>
                                    </div>
                                </el-image>
                            </div>
                        </el-card>

                    </div>
                </div>
            </div>
        </div>

        <!-- 选择岗位 -->
        <el-dialog
                class="btn-2b5a95"
                width="50%"
                v-dialogDrag
                @close="onHandleCloseSelect"
                title="选择岗位："
                :close-on-click-modal='false'
                :visible.sync="showPostDataModal"
                v-if="showPostDataModal"
                append-to-body
        >
            <el-button type="primary" class="confirm" @click="submitPost"
            >确 定</el-button
            >
            <div class="index_2 btn-2b5a95">
                <div
                        class="l-w"
                        :style="{
            height: $store.state.global.isSearchExtend_2
              ? ''
              : $store.state.global.searchFormHeight_2 + 10 + 'px',
          }"
                >
                    <el-form
                            label-position="right"
                            :class="
              $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
            "
                            :model="selectSearchForm"
                            @submit.native.prevent
                    >
                        <el-form-item label="岗位名称:" prop="postname">
                            <el-input
                                    v-model.trim="selectSearchForm.postname"
                                    @keyup.enter.native="onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign(
                  {
                    //schoolorgid: dynamicValidateForm.schoolorgid,
                    //leaveflag: 0,
                  },
                  selectSearchForm
                )
              )"
                                    clearable />
                        </el-form-item>
                    </el-form>
                </div>
                <div class="r-w">
                    <el-button
                            type="primary"
                            icon="el-icon-search"
                            :loading="!$store.state.global.isEndRequest"
                            class="btn-2b5a95"
                            @click="
              onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign(
                  {
                    //schoolorgid: dynamicValidateForm.schoolorgid,
                    //leaveflag: 0,
                  },
                  selectSearchForm
                )
              )
            "
                    >搜索</el-button
                    >
                    <!-- <el-button type="primary" @click="handleQuery">重置</el-button> -->
                    <el-button
                            type="primary"
                            :icon="
              $store.state.global.isSearchExtend_2
                ? 'el-icon-arrow-up'
                : 'el-icon-arrow-down'
            "
                            v-if="$store.state.global.searchExtend_2"
                            class="btn-2b5a95"
                            @click="onExtendClick('isSearchExtend_2')"
                    >{{ $store.state.global.searchExtendText_2 }}</el-button
                    >
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                    :data="selectTable.list"
                    style="width: 100%"
                    border
                    :key="key"
                    stripe
                    :header-cell-style="{background: '#004d8c', color:'#FFFFFF'}"
                    @select="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" />
                <el-table-column label="流水号" prop="id" align="center" />
                <el-table-column label="岗位" prop="postname" align="center" />
                <el-table-column label="录入时间" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.inserttime | formatDate("YYYY-MM-DD HH:mm:ss") }}
                    </template>
                </el-table-column>

            </el-table>
            <!-- 分页 -->
            <el-pagination
                    background
                    @current-change="
          (val, data, prop, page) =>
            handleSelectChange(
              val,
              Object.assign(
                {
                  //schoolorgid: dynamicValidateForm.schoolorgid,
                  //leaveflag: 0,
                },
                selectSearchForm
              )
            )
        "
                    :current-page="selectPageInfo.pageindex"
                    :page-size="selectPageInfo.pagesize"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    layout="total, prev, pager, next, jumper"
                    :total="selectTable.totalcount"
            ></el-pagination>
        </el-dialog>

        <!-- 查看已选岗位列表 -->
        <el-dialog
                class="btn-2b5a95"
                width="80%"
                v-dialogDrag
                @close="onHandleCloseSelect"
                title="岗位列表："
                :visible.sync="showModal"
                :close-on-click-modal='false'
                v-if="showModal"
                append-to-body

        >
            <div class="index_2 btn-2b5a95">
                <div
                        class="l-w"
                        :style="{
            height: $store.state.global.isSearchExtend_2
              ? ''
              : $store.state.global.searchFormHeight_2 + 10 + 'px',
          }"
                >
                    <el-form
                            label-position="right"
                            :class="
              $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
            "
                            :model="selectSearchForm"
                            @submit.native.prevent
                    >
                        <el-form-item label="岗位名称:">
                            <el-input
                                    v-model.trim="selectSearchForm.postname"
                                    @keyup.enter.native="selectSeach"
                                    clearable />
                        </el-form-item>
                    </el-form>
                </div>
                <div class="r-w">
                    <el-button
                            type="primary"
                            icon="el-icon-search"
                            :loading="!$store.state.global.isEndRequest"
                            class="btn-2b5a95"
                            @click="selectSeach"
                    >搜索</el-button
                    >
                    <el-button type="primary" @click="handleChangeQuery">重置</el-button>
                    <el-button
                            type="primary"
                            :icon="
              $store.state.global.isSearchExtend_2
                ? 'el-icon-arrow-up'
                : 'el-icon-arrow-down'
            "
                            v-if="$store.state.global.searchExtend_2"
                            class="btn-2b5a95"
                            @click="onExtendClick('isSearchExtend_2')"
                    >{{ $store.state.global.searchExtendText_2 }}</el-button
                    >
                </div>
            </div>
            <!--
            <div class="select-btn" style="margin-bottom: 20px;">
                <el-button type="primary" @click="btnDetailEdit">修改</el-button>
                <el-button type="primary" @click="btnDetailDel">删除</el-button>
                <el-button type="primary" @click="btnDetailReload">刷新</el-button>
            </div>
            -->
            <el-table
                    :data="selectTable.list"
                    style="width: 100%"
                    border
                    stripe
                    :header-cell-style="{background: '#004d8c', color:'#FFFFFF'}"
                    ref="moneyTable"
                    @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" />
                <el-table-column label="流水号" prop="id" align="center" />
                <el-table-column label="姓名" prop="fullname" align="center" />
                <el-table-column label="联系电话" prop="mobile" align="center" />
                <el-table-column label="意向岗位" prop="postname" align="center" />


                <el-table-column label="状态" align="" width="500">
                    <template slot-scope="scope">
                        <select v-model="scope.row.status" style="border: 1px solid #ccc;color: #606266">
                            <option label="未面试" value="未面试" />
                            <option label="已面试" value="已面试" />
                            <option label="未签约" value="未签约" />
                            <option label="已签约" value="已签约" />
                            <option label="未录用" value="未录用" />
                            <option label="已录用" value="已录用" />
                        </select>
                        &nbsp;&nbsp;
                        备注：<el-input v-model="scope.row.remarks" style="width:212px;heigth:10px;" clearable></el-input>
                        &nbsp;&nbsp;
                        <button style="width:80px;" type="primary" @click="btnUpdatePost(scope.row)">保存</button>
                    </template>
                </el-table-column>

                <el-table-column label="教学点" prop="schoolorgname" align="center" />

                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="createResume(scope.row)"
                        >生成简历</el-button
                        >
                    </template>
                </el-table-column>

            </el-table>
            <el-pagination
                    background
                    @current-change="
				  (val, data) => handleSelectChange(val, Object.assign({workersid: this.itemId}))
				"
                    :current-page="selectPageInfo.pageindex"
                    :page-size="selectPageInfo.pagesize"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    layout="total, prev, pager, next, jumper"
                    :total="selectTable.totalcount"
            ></el-pagination>
        </el-dialog>

        <!--简历模板-->
        <el-dialog
                class="btn-2b5a95"
                width="80%"
                v-dialogDrag
                @close="onHandleCloseResumeModal"
                title="简历："
                :visible.sync="resumeModal"
                :close-on-click-modal='false'
                v-if="resumeModal"
                append-to-body

        >
            <div>
                <label>打印包含以下信息：</label>
            </div>
            <div>
                <input type="checkbox"  v-model="isCheckedMobile">
                <label>手机号</label>
            </div>
            <div>
                <input type="checkbox"  v-model="isCheckedIdcard">
                <label>身份证号</label>
            </div>



            <div id="printContent">
                <div class="resume_div" style="width:950px; margin-bottom: 30px;">
                    <div class="top_el">
                        香港外派劳务人员基本情况表
                    </div>
                    <br><br>
                    <div>
                        <sapn style="margin-left: 550px;">编号：
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </sapn>
                        <span style="">应聘岗位： {{vworkerspost.postname}} </span>

                    </div>

                    <el-form>
                        <table class="tabledetail_2" style="width: 100%;" cellpadding="5px">
                            <tbody>
                            <tr align="center" >
                                <td>姓名</td>
                                <td>{{ vworkers.fullname }}</td>
                                <td>性别</td>
                                <td>{{ vworkers.sexval }}</td>
                                <td>出生日期</td>
                                <td>{{ vworkers.birthday | formatDate("YYYY-MM-DD") }}</td>
                                <td>年龄</td>
                                <td>{{ vworkers.age }}</td>
                                <td rowspan="4" align="center" valign="middle" style="width: 161px; height: 200px">
                                    <el-image :src="vworkers.pic ? this.$url.upload + vworkers.pic : '' " style="width: 161px; height: 200px">
                                        <div slot="error" class="image-slot el-image__error">
                                            <i class="el-icon-picture-outline"></i>
                                            <span>暂无照片</span>
                                        </div>
                                    </el-image>
                                    <p>照片</p>
                                </td>
                            </tr>

                            <tr align="center" >
                                <td>身高</td>
                                <td>{{ vworkers.height }} cm</td>
                                <td>体重</td>
                                <td>{{ vworkers.weight }} kg</td>
                                <td>籍贯</td>
                                <td>{{ vworkers.comefrom }}</td>
                                <td>婚否</td>
                                <td>{{ vworkers.marryval }}</td>
                            </tr>

                            <tr align="center" >
                                <td>民族</td>
                                <td>{{ vworkers.nationval }}</td>
                                <td colspan="2">现住地址</td>
                                <td colspan="4">{{ vworkers.nowaddr }}</td>
                            </tr>

                            <tr align="center" >
                                <td>电话</td>
                                <td colspan="3">{{isCheckedMobile ? vworkers.mobile : '' }}</td>
                                <td colspan="2">技术职称/专业证书</td>
                                <td colspan="2">{{ vworkers.certificate }}</td>
                            </tr>

                            <tr align="center" >
                                <td colspan="1">身份证号码</td>
                                <td colspan="3">{{ isCheckedIdcard ? vworkers.idcard : ''}}</td>
                                <td colspan="2">紧急联系人及电话</td>
                                <td colspan="3">{{ vworkers.urgentperson }}</td>
                            </tr>

                            <tr align="center" >
                                <td colspan="1">户籍地址</td>
                                <td colspan="5">{{ vworkers.domicile }}</td>
                                <td colspan="2" rowspan="2">是否曾在<br>香港工作</td>
                                <td colspan="1" rowspan="2">{{ vworkers.iswork ==1 ? "是":"否" }}</td>
                            </tr>

                            <tr align="center" >
                                <td colspan="1">港澳通行证号码</td>
                                <td colspan="5">{{ vworkers.pass }}</td>
                            </tr>

                            <tr align="center" >
                                <td align="center" :rowspan="list1.length + 1" class="">（从高向低填）<br>受教育情况</td>
                                <td colspan="2">就读时间</td>
                                <td colspan="2">学校</td>
                                <td colspan="2">专业</td>
                                <td colspan="2">学历</td>
                            </tr>

                            <tr v-for="item in list1" :key="item.id" align="center" >
                                <td colspan="2">{{item.studytime}}</td>
                                <td colspan="2">{{item.collegename}}</td>
                                <td colspan="2">{{item.majorname}}</td>
                                <td colspan="2">{{item.education}}</td>
                            </tr>

                            <tr align="center" >
                                <td align="center" rowspan="3">语言<br>水平</td>
                                <td>语种</td>
                                <td colspan="2">阅读</td>
                                <td colspan="1">听说</td>
                                <td colspan="1">写作</td>
                                <td colspan="3">考试种类及等级</td>
                            </tr>

                            <tr align="center" >
                                <td>粤语</td>
                                <td colspan="2">{{vworkers.read}}</td>
                                <td colspan="1">{{vworkers.heard}}</td>
                                <td colspan="1">{{vworkers.write}}</td>
                                <td colspan="3">{{vworkers.grade}}</td>
                            </tr>

                            <tr align="center" >
                                <td>英语</td>
                                <td colspan="2">{{vworkers.read2}}</td>
                                <td colspan="1">{{vworkers.heard2}}</td>
                                <td colspan="1">{{vworkers.write2}}</td>
                                <td colspan="3">{{vworkers.grade2}}</td>
                            </tr>

                            <tr align="center" >
                                <td :rowspan="list2.length + 1">（从后向前填）<br>工作经历</td>
                                <td colspan="2">起止时间</td>
                                <td colspan="2">工作单位及部门</td>
                                <td colspan="2">担任职务或工作岗位</td>
                                <td colspan="2">职责范围</td>
                            </tr>
                            <tr v-for="item in list2" :key="item.id" align="center" >
                                <td colspan="2">{{item.startendtime}}</td>
                                <td colspan="2">{{item.workunit}}</td>
                                <td colspan="2">{{item.post}}</td>
                                <td colspan="2">{{item.responsibility}}</td>
                            </tr>

                            <tr align="center">
                                <td align="center" rowspan="3">求<br>职<br>意<br>向</td>
                                <td>欲从事工作</td>
                                <td colspan="2">①:{{vworkers.work1}}</td>
                                <td colspan="2">②:{{vworkers.work2}}</td>
                                <td colspan="2">③:{{vworkers.work3}}</td>
                                <td>④:{{vworkers.work4}}</td>
                            </tr>
                            <tr align="center">
                                <td>有何特长</td>
                                <td colspan="7">{{vworkers.talent}}</td>
                            </tr>
                            <tr align="center">
                                <td>现时工资</td>
                                <td colspan="3">{{vworkers.nowwages}}</td>
                                <td>求职希望工资</td>
                                <td colspan="3">{{vworkers.hopewages}}</td>
                            </tr>

                            <tr>
                                <td align="center">备<br>注</td>
                                <td colspan="8">应聘者承诺：<br>
                                    &nbsp;&nbsp;&nbsp;本表所填各项数据为本人真实意愿填写，保证内容完整、属实，并愿意接受背景调查。如有虚报愿意承担各项处分及一切后果。
                                <br><br><br>
                                    <p></p>
                                    <div align="center">应聘者签名：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        填表日期：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 年 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 月  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日</div>
                                </td>
                            </tr>




                            </tbody>
                        </table>
                    </el-form>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                 <el-button type="primary" v-print="'#printContent'" >打印</el-button>
                 <el-button @click="resumeModal = false">取 消</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
    import { _available } from "@/assets/js/filedValueFlag";
    import { mapActions } from "vuex";
    import { part } from "@/utils/mixins";
    import {
        workers_list,
        workers_input,
        workers_show,
        workers_save,
        workers_delete,
        post_dialogresult,
        workerspost_save,
        workerspost_list2,
        workerspost_update,
        workerspost_resumeshow,
    } from "@/request/api/allChildrenProject";
    import { dic_combox,_vuser_dialogresult, } from "@/request/api/public";
    import { myRequest } from "@/request/index";
    import {
        selectCheck,
        confirmCallBack,
        messageTip,
        createObjParams,
        formatDare,
    } from "@/utils/util";
    import { _fileupload_save, _filedownload_save } from "@/request/api/public";
    import Level from "../../personnel/org/table/levelMoudle/index";

    export default {
        mixins: [part],
        name: "fileshare",
        components: {Level},
        props: {
            vuser_dialogresult: {
                default: () => _vuser_dialogresult,
            },
        },
        data() {
            return {
                itemId: null, //首表格项id
                searchForm: {},
                tableRes: {}, //列表接口
                pageinfo: {
                    pageindex: 1,
                    pagesize: 10,
                }, //页数查询
                showAddModal: false, //显示表单框
                multipleSelection: [], //选中的表格项
                rules: {
                    companyorgname: [{ trigger: "blur", message: "必填字段", required: true }],// 分公司
                    schoolorgid: [{ trigger: "blur", message: "必填字段", required: true }],//教学点
                    fullname: [{ trigger: "blur", message: "必填字段", required: true }],//姓名
                    //mobile: [{ trigger: "blur", message: "必填字段", required: true }],//手机号
                    mobile: [{required: true, trigger: "blur",}, {pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, message: "请输入正确的手机号码"}], // 手机
                    followusername: [{ trigger: "blur", message: "必填字段", required: true }],//跟进人
                }, //表单规则
                dialogTitle: "", //对话框标题
                fds: new FormData(),

                available: _available,//是、否
                nation: [], //名族
                dynamicValidateForm:{//表单
                    moreItems1: [
                        {
                            studytime: "",
                            collegename: "",
                            majorname: "",
                            education: "",
                        },
                    ],
                    moreItems2: [
                        {
                            startendtime: "",
                            workunit: "",
                            post: "",
                            responsibility: "",
                            workurl: "",
                        },
                    ],
                },

                followDisabled: false,//跟进人禁用与启用
                addEditDisable: false, // 禁用与启用
                showFollowDataModal: false, //显示表单框(选择跟进人)
                selectSearchForm: {}, // 选择搜索
                selectPageInfo: {
                    pageindex: 1,
                    pagesize: 10,
                }, // 选择框分页
                selectTableUrl: null, // 选择的路径
                schoolList: [], // 所属教学点
                companylist: [], // 所属分公司
                studytime:"",
                iswork:0,
                tabList:['基本信息','证件信息'],
                showDetailModal:false,
                vworkers:{},
                srcList: [],
                currentTab: 0,//当前标签页（详情）
                currentClass: 0,//当前样式（详情）
                list1:[],//查看详情里面的教育经历
                list2:[],//查看详情里面的工作经历
                showPostDataModal:false,
                key: '',
                ids:[],//务工人员数组，选岗位用
                showModal: false,//查看岗位列表
                selectTable: {},
                resumeModal:false,//简历模板
                isCheckedMobile:false,//打印包含手机号
                isCheckedIdcard:false,//打印包含身份证号

            };
        },
        created() {
            // 获取所有分公司
            this.org_combox();
            this.org_comboxchild(this.dynamicValidateForm.companyorgid);
            // 获取列表
            this.getDataList();
            // 获取民族
            this.getPulicList("nation", "nationList");
        },
        methods: {
            ...mapActions("global", ["onExtendClick",'isExpand']), //搜索 click
            ...mapActions("selectData", [
                "org_combox",
                "org_comboxchild",
                "dic_combox",
            ]),
            seach() {
                this.pageinfo.pageindex = 1;
                this.getDataList();
            },
            //列表查询 api
            getDataList() {
                myRequest({
                    url: workers_list,
                    data: Object.assign(this.searchForm, this.pageinfo),
                }).then((res) => {
                    if (res.data.code === "200") {
                        this.tableRes = res.data.data;
                    }
                });
            },
            //切换当前页
            handleCurrentChange(val) {
                this.pageinfo.pageindex = val;
                this.getDataList();
            },
            //触发所有btn方法
            onClickBtn(methodsName) {
                this.$options.methods[methodsName].call(this); //btnAdd ... （防止修改this指向）
            },

            //添加click
            btnAdd() {
                this.dialogTitle = "添加";
                this.addEditDisable = false; // 禁用与启用
                this.followDisabled = false; //禁用与启用
                this.dynamicValidateForm = {//表单
                    moreItems1: [
                        {
                            studytime: "",
                            collegename: "",
                            majorname: "",
                            education: "",
                        },
                    ],
                        moreItems2: [
                        {
                            startendtime: "",
                            workunit: "",
                            post: "",
                            responsibility: "",
                            workurl: "",
                        },
                    ],

                    schoolorgid: this.$store.state.login.userinfo.schoolorgid,
                    companyorgid: this.$store.state.login.userinfo.companyorgid,
                    followusername: this.$store.state.login.userinfo.realname,
                    followuserid: this.$store.state.login.userinfo.id,
                     pic:"",
                    idphoto: "",
                    idphoto2:"",
                    passphoto:"",
                    passphoto2:"",
                    registerphoto:"",
                    bodyphoto:"",
                    flairphoto:"",
                    videourl:"",
                    iswork:0,
                };

                this.$set(
                    this.dynamicValidateForm,
                    "companyorgname",
                    this.$store.state.login.userinfo.companyorgname
                );
                this.$set(
                    this.dynamicValidateForm,
                    "schoolorgname",
                    this.$store.state.login.userinfo.schoolorgname
                );
                this.org_comboxchild(this.dynamicValidateForm.companyorgid);

                this.showAddModal = true;
            },
            //修改click
            btnEdit() {
                this.dialogTitle = "修改";
                selectCheck(this.multipleSelection, "修改", false, () => {
                    this.editRoutePage(this.multipleSelection[0].id);
                });
            },
            //删除click
            btnDel() {
                selectCheck(this.multipleSelection, "删除", true, () => {
                    confirmCallBack({
                        title: "提示",
                        content: "此操作将永久删除选中的数据！",
                        success: () => {
                            this.delTableItem(this.multipleSelection.map((i) => i.id));
                        },
                        fail: () => {
                            messageTip({
                                message: "取消操作",
                                type: "info",
                            });
                        },
                    });
                });
            },
            //上传文件前 before
            beforeUpload(file) {
                this.fds.append("upfile", file); // 传文件
            },
            //上传文件 upload
            uploadFile(prop) {
                myRequest({
                    method: "post",
                    url: _fileupload_save,
                    data: this.fds,
                }).then((res) => {
                    if (res.data.code === "200") {
                        this.fds = new FormData();
                        this.dynamicValidateForm[prop] = res.data.url;
                    }
                });
            },

            //上传文件（循环里面） upload
            uploadFile2(index) {
                myRequest({
                    method: "post",
                    url: _fileupload_save,
                    data: this.fds,
                }).then((res) => {
                    if (res.data.code === "200") {
                        this.fds = new FormData();
                        //this.dynamicValidateForm.moreItems2[index] = res.data.url;
                        this.$set(this.dynamicValidateForm.moreItems2[index], 'workurl', res.data.url);
                    }
                });
            },

            //下载 click
            downloadFile(row) {
                location.href =
                    this.$url.Freemarker + _filedownload_save + "?fileurl=" + row.fileurl;
            },
            reset() {
                this.searchForm = {
                    title: null,
                    username: null,
                    schoolorgname: null
                }
            },
            resetQuery() {
                this.reset();
                this.getDataList();
            },
            //刷新 click
            btnRefresh() {
                this.getDataList();
            },
            //修改路由页 api
            editRoutePage(id) {
                myRequest({
                    url: workers_input,
                    data: {
                        id: id,
                    },
                }).then((res) => {
                    if (res.data.code === "200") {
                        this.showAddModal = true;
                        this.dynamicValidateForm = res.data.data.vworkers;

                        this.$set(this.dynamicValidateForm, "moreItems1", []);
                        this.$set(this.dynamicValidateForm, "moreItems2", []);
                        for (let i in res.data.data.list1) {
                            this.dynamicValidateForm.moreItems1.push(res.data.data.list1[i]);
                        }
                        for (let i in res.data.data.list2) {
                            this.dynamicValidateForm.moreItems2.push(res.data.data.list2[i]);
                        }

                        // this.dynamicValidateForm.moreItems1=res.data.data.list1;//这种方式也可以渲染修改界面，但在增加一行时无法及时渲染。
                        // this.dynamicValidateForm.moreItems2=res.data.data.list2;//这种方式也可以渲染修改界面，但在增加一行时无法及时渲染。

                        this.dynamicValidateForm.birthday = formatDare(
                            this.dynamicValidateForm.birthday,
                            "YYYY-MM-DD HH:mm:ss"
                        );
                         delete this.dynamicValidateForm.insertuserid;//该字段不用传
                         delete this.dynamicValidateForm.inserttime; //inserttime 该字段不用传
                         delete this.dynamicValidateForm.deleteflag;//该字段不用传
                        delete this.dynamicValidateForm.status;//该字段不用传


                    }
                });
            },

            //删除 api
            delTableItem(idArr) {
                myRequest(
                    {
                        method: "post",
                        url: workers_delete,
                        data: this.$qs.stringify(
                            {
                                ids: idArr,
                            },
                            {
                                arrayFormat: "repeat",
                            }
                        ),
                    },
                    {
                        isRefTableList: true,
                        that: this,
                    }
                );
            },

            //切换选项表格页
            handleSelectChange(val, data, prop, page) {
                this.selectPageInfo.pageindex = val;
                this.onSelectData(
                    this.selectTableUrl,
                    null,
                    data,
                    this.itemRow,
                    prop,
                    page
                );
            },
            //选中表格数据改变时
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },

            //添加一行 - （受教育情况） click
            report_addFormItem1() {
                this.dynamicValidateForm.moreItems1.push({
                    studytime: "",
                    collegename: "",
                    majorname: "",
                    education: "",
                });
            },
            //添加一行 - （家庭成员） click
            report_addFormItem2() {
                this.dynamicValidateForm.moreItems2.push({
                    startendtime: "",
                    workunit: "",
                    post: "",
                    responsibility: "",
                    workurl: "",
                });
            },


            //删除一行 click
            report_onRemoveMoreForm(index, prop) {
                this.dynamicValidateForm[prop].splice(index, 1);
            },

            //改变分公司 change
            onChangeCompany(val, form) {
                this[form].schoolorgname = "";
                this[form].companyorgid = val;
                this[form].shoujucode = "";
                this.org_comboxchild(val);
            },
            // 改变教学点
            onChangeSchool(val, form) {
                this[form].schoolorgid = val;
                this[form].year = "";
                this[form].grade = "";
                this[form].collegename1 = "";
                this[form].majorname1 = "";
                this[form].levelval = "";
            },

            //选项表格 api
            onSelectData(url, modal, data, row, prop, page) {
                this.selectIndex = data?.index;
                this.selectTableUrl = url;
                myRequest({
                    url: this.selectTableUrl,
                    data: Object.assign(data || {}, this.selectPageInfo),
                }).then((res) => {
                    if (res.data.code === "200") {
                        this.dynamicValidateForm.index = res.data.data.index;
                        this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
                        this.selectTable = res.data.data;
                        this.key = Math.random();
                        this[modal] = true;
                    }
                });
            },

            // 增加-跟进人确定
            followDataComfirm() {
                this.dynamicValidateForm.followusername = this.multipleSelection[0].realname;
                this.dynamicValidateForm.followuserid = this.multipleSelection[0].id;
                this.showFollowDataModal = false;
                this.multipleSelection = [];
                this.selectQuery();
            },
            selectQuery() {
                this.selectSearchForm = {
                    collegename: null,
                    collegemajorname: null,
                    majorlevelval: null,
                    schoolorgname: null,
                    classname: null,
                    name: null,
                    typename: null,
                    type1name: null,
                    accountname: null,
                    realname: null,
                    fudaoclasstypename: null,
                    fudaotypeval: null,
                }
            },

            handleQuery() {
                this.selectQuery();
                this.onSelectData(
                    this.selectTableUrl,
                    null,
                    null,
                    null,
                    null,
                    null
                );
            },
            onHandleCloseSelect() {
                this.onCloseSelect();
                this.handleQuery();
            },
            //关闭选项框 click
            onCloseSelect() {
                this.selectPageInfo.pageindex = 1;
            },
            //选项表格 - 搜索 click
            onSelectSearchClick(url, modal, data) {
                this.selectPageInfo.pageindex = 1;
                this.onSelectData(url, modal, data);
            },
            // 获取公共数组方法
            getPulicList(params, list) {
                myRequest({
                    url: dic_combox,
                    data: {
                        typecode: params,
                    },
                }).then((res) => {
                    if (res.data.code === "200") {
                        this[list] = res.data.data.list;
                    }
                });
            },

            //新增、修改提交
            submitAddOrEditForm(dynamicValidateForm) {
                this.dynamicValidateForm.birthday = formatDare(
                    this.dynamicValidateForm.birthday,
                    "YYYY-MM-DD HH:mm:ss"
                );
                const moreItemKey = [
                    "studytime",
                    "collegename",
                    "majorname",
                    "education",
                    "startendtime",
                    "workunit",
                    "post",
                    "responsibility",
                    "workurl",
                ];
                moreItemKey.map((i) => (this.dynamicValidateForm[i] = []));
                const moreDataKey = ["moreItems1", "moreItems2"];

                for (let moreKey in moreDataKey){
                    for(let j in moreItemKey){
                        for(let i in this.dynamicValidateForm[moreDataKey[moreKey]]){
                            for (let key in this.dynamicValidateForm[moreDataKey[moreKey]][i]){
                                if (this.dynamicValidateForm[moreDataKey[moreKey]][i][key] && key === moreItemKey[j]) {
                                    //有值才push，否则是空字符串
                                    this.dynamicValidateForm[key].push(this.dynamicValidateForm[moreDataKey[moreKey]][i][key]);
                                }
                            }
                        }
                    }
                }
                this.$refs[dynamicValidateForm].validate((valid) => {
                    if (valid) {
                        myRequest({
                                method: "post",
                                url: workers_save,
                                data: this.$qs.stringify(this.dynamicValidateForm, {arrayFormat: "repeat",}),
                            },
                            {
                                isRefTableList: true,
                                that: this,
                                modal: "showAddModal",
                            }
                        )
                    }
                });
            },

            // 查看详情 clik
            watchDetail(id) {
                this.tabId = id;
                myRequest({
                    url: workers_show,
                    data: {
                        id: id
                    },
                }).then((res) => {
                    if (res.data.code === "200") {
                        this.dialogTitle = "查看";
                        this.watchDetailList = res.data.data;
                        this.vworkers = this.watchDetailList.vworkers;
                        this.list1 = this.watchDetailList.list1;
                        this.list2 = this.watchDetailList.list2;
                        this.showDetailModal = true;
                        this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
                    }
                });
            },

            //隐藏和显示
            handleShow(){
                this.showDetailModal = false;
            },

            vbs(val) {
                this.srcList = []
                this.srcList.push(val)
            },

            //改变切换栏
            toggleTab(current) {
                this.currentTab = current;
                this.currentClass = current;
            },
            //选岗位
            btnSelectPost(){
                this.ids = this.multipleSelection.map((i) => i.id);
                selectCheck(this.multipleSelection, "操作", true, () => {
                    this.onSelectData(post_dialogresult,'showPostDataModal',{})
                });

            },

            //选岗位提交
            submitPost(){
                var postids = this.multipleSelection.map((i) => i.id);//选择岗位集合
                //console.log('ids:',this.ids);
                //console.log('postids:',postids);
                myRequest(
                    {
                        method: "post",
                        url: workerspost_save,
                        data: this.$qs.stringify(
                            {
                                ids: this.ids,
                                postids:postids,
                            },
                            {
                                arrayFormat: "repeat",
                            }
                        ),
                    },
                    {
                        isRefTableList: true,
                        that: this,
                    }
                ).then((res) => {
                    if (res.data.code === "200") {
                        this.showPostDataModal = false;
                    }
                });

                this.multipleSelection = [];//提交之后，把选择的数据清空
            },

            //查看已选岗位列表
            showPost(row){
                this.itemId = row.id;
                this.onSelectData(workerspost_list2, "showModal", {workersid: this.itemId,});
            },

            // 岗位列表里面的搜索
            selectSeach() {
                this.pageinfo.pageindex = 1;
                this.onSelectData(workerspost_list2, "showModal",
                    {workersid: this.itemId,
                        postname:this.selectSearchForm.postname,});
            },

            //岗位列表里面的重置
            handleChangeQuery() {
                this.selectSearchForm = {
                    postname: null
                }
                this.onSelectData(workerspost_list2, null, {
                    workersid: this.itemId,
                });
            },

            //修改岗位状态
            btnUpdatePost(row){
                myRequest({
                    url: workerspost_update,
                    data: {
                        id: row.id,
                        status: row.status,
                        remarks:row.remarks,

                    },
                }).then((res) => {
                    if (res.data.code === "200") {
                        this.key = Math.random();
                        this.getDataList();
                        this.onSelectData(workerspost_list2, "showModal", {workersid: this.itemId,});
                    }
                });
            },

            //生成简历
            createResume(row){
                myRequest({
                    url: workerspost_resumeshow,
                    data: {
                        workerspostid: row.id
                    },
                }).then((res) => {
                    if (res.data.code === "200") {
                        //this.dialogTitle = "查看";
                        this.watchDetailList = res.data.data;
                        this.vworkers = this.watchDetailList.vworkers;
                        this.vworkerspost = this.watchDetailList.vworkerspost;
                        this.list1 = this.watchDetailList.list1;
                        this.list2 = this.watchDetailList.list2;
                        this.resumeModal = true;
                        this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
                    }
                });

            },

            //关闭简历窗口
            onHandleCloseResumeModal(){
                this.onCloseSelect();
                //this.onSelectData(workerspost_list2, "showModal", {workersid: this.itemId,});
            },

            //打印简历（未用上）
            btnPrint(){
                window.print();
            }


        },
    };
</script>

<style lang="scss">
    .base_table{
        margin: auto;
    }

    .input_100{
        width:100px;
    }
    .input_150{
        width:150px;
    }
    .input_180{
        width:180px;
    }
    .input_200{
        width:200px;
    }
    .input_300{
        width:300px;
    }
    .input_400{
        width:400px;
    }
    .select_1{
        width:100px;
    }

    .custom-spacing {
        margin-bottom: 10px; /* 调整为需要的间距 */
    }
    .div_1{
        border: 1px solid #ccc;
    }
    .p_1{
        font-size: 16px;
    }

    .tabledetail_1{//查看人员详情样式
        border: 2px solid ;
        border-collapse: collapse;
        border-spacing: 0;
        font: 90% "Trebuchet MS", Tahoma, Arial, Helvetica, sans-serif;
        font-family: '宋体', SimSun, sans-serif; // 设置字体为宋体
        font-size: 14px; // 设置字体大小为14
        td{
            border-right: 1px solid ;
            border-bottom: 1px solid ;
            border-top: 0px;
            border-left: 0px;
            vertical-align: middle;
            display: table-cell;
            width: auto;
        }
    }

    .tabledetail_2{//打印简历表格样式
        border: 2px solid ;
        border-collapse: collapse;
        border-spacing: 0;
        font: 90% "Trebuchet MS", Tahoma, Arial, Helvetica, sans-serif;
        font-family: '宋体', SimSun, sans-serif; // 设置字体为宋体
        font-size: 16px; // 设置字体大小为16
        td{
            border-right: 1px solid ;
            border-bottom: 1px solid ;
            border-top: 0px;
            border-left: 0px;
            vertical-align: middle;
            display: table-cell;
            width: auto;
            height: 35px;
        }
    }

    .tr_1{
        height:12px;
    }

    //简历
    .resume_div{
        //background: #fff;
        position: relative;
        //border: 1px solid #4d5d6f;
        margin: auto;
        .top_el{
            text-align: center;
            line-height: 35px;
            font-size: 30px;
            //color: #904209;
        }
    }

    .text-right {
        text-align: right;
    }


    @import "../../../assets/css/pulid.scss";

</style>
